import { render, staticRenderFns } from "./original-home.vue?vue&type=template&id=0d4045df&scoped=true&"
import script from "./original-home.vue?vue&type=script&lang=js&"
export * from "./original-home.vue?vue&type=script&lang=js&"
import style0 from "./original-home.vue?vue&type=style&index=0&id=0d4045df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4045df",
  null
  
)

export default component.exports